<template>
	<campaigns-tooltip-label
		tooltip="Determines who should be able to view this campaign."
		label="Who should see this campaign?"
		class="omapi-campaign-settings__user-setting"
	>
		<select v-model="settingUsers" class="omapi-input omapi-input__select" :disabled="hasError">
			<option value="">All Visitors and Logged-In Users</option>
			<option value="out">Visitors Only</option>
			<option value="in">Logged-In Users Only</option>
		</select>
	</campaigns-tooltip-label>
</template>

<script lang="js">
import { campaign } from '@/campaigns/mixins/campaign'
import { mapGetters } from 'vuex'

export default  {
	mixins : [ campaign ],
	props  : {
		/**
		 * Campaign Id
		 */
		campaignId : {
			type : String,
			default: '',
		},
	},
	computed : {
		...mapGetters('campaigns', [ 'getCampaign', 'hasError' ]),
		/**
		 * Get the campaign object.
		 * @returns {Object} The campaign object.
		 */
		campaign () {
			return this.getCampaign(this.campaignId)
		},

	},
};
</script>
